export const selectedSoundtrackIds = [
  "chrome-coil",
  "meteorcoil",
  "sidewinder-stomp",
  "crown-of-sparks",
] as const;

export type SelectedSoundtrackId = (typeof selectedSoundtrackIds)[number];

export const decodedSoundtrackCacheLimit = 1;

export interface SelectedSoundtrackConfig {
  readonly id: SelectedSoundtrackId;
  readonly name:
    "Chrome Coil" | "Meteorcoil" | "Sidewinder Stomp" | "Crown of Sparks";
  readonly playbackGain: number;
}

export const defaultSelectedSoundtrackId =
  "meteorcoil" as const satisfies SelectedSoundtrackId;

export const selectedSoundtrackConfigs = {
  "chrome-coil": {
    id: "chrome-coil",
    name: "Chrome Coil",
    playbackGain: 0.28,
  },
  meteorcoil: {
    id: "meteorcoil",
    name: "Meteorcoil",
    playbackGain: 0.28,
  },
  "sidewinder-stomp": {
    id: "sidewinder-stomp",
    name: "Sidewinder Stomp",
    playbackGain: 0.28,
  },
  "crown-of-sparks": {
    id: "crown-of-sparks",
    name: "Crown of Sparks",
    playbackGain: 0.28,
  },
} as const satisfies Readonly<
  Record<SelectedSoundtrackId, SelectedSoundtrackConfig>
>;

const selectedSoundtrackIdSet = new Set<string>(selectedSoundtrackIds);

export const isSelectedSoundtrackId = (
  value: unknown,
): value is SelectedSoundtrackId =>
  typeof value === "string" && selectedSoundtrackIdSet.has(value);

export const requireSelectedSoundtrackId = (
  value: string,
): SelectedSoundtrackId => {
  if (!isSelectedSoundtrackId(value)) {
    throw new Error(`Soundtrack track is not owner-selected: ${value}`);
  }
  return value;
};
